import { render } from "./AddonsNew.vue?vue&type=template&id=05fdfc0e&scoped=true"
import script from "./AddonsNew.vue?vue&type=script&lang=js"
export * from "./AddonsNew.vue?vue&type=script&lang=js"

import "./AddonsNew.vue?vue&type=style&index=0&id=05fdfc0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fdfc0e"]])

export default __exports__